/* unplugin-vue-components disabled */import { render } from "./loading.vue?vue&type=template&id=f60b53d0&scoped=true&ts=true"
import script from "./loading.vue?vue&type=script&lang=ts"
export * from "./loading.vue?vue&type=script&lang=ts"

import "./loading.vue?vue&type=style&index=0&id=f60b53d0&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60b53d0"],['__file',"src/baseui/loading/loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f60b53d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f60b53d0', __exports__)) {
    console.log('reload')
    api.reload('f60b53d0', __exports__)
  }
  
  module.hot.accept("./loading.vue?vue&type=template&id=f60b53d0&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('f60b53d0', render)
  })

}


export default __exports__